import { InvitationTemplate } from '../../types/invitation';

export const invitationTemplates: InvitationTemplate[] = [
  {
    id: 0,
    name: '經典粉金',
    style: 'classic',
    primaryColor: '#E6A4B4',
    secondaryColor: '#C0A06F',
    preview: '/template-previews/classic.jpg',
    description: '經典粉金配色，溫柔典雅，最受新人喜愛的百搭款式'
  },
  {
    id: 1,
    name: '粉櫻夢境',
    style: 'romantic',
    primaryColor: '#ec4899',
    secondaryColor: '#f9a8d4',
    preview: '/template-previews/romantic.jpg',
    description: '櫻花粉夢幻風格，手寫感字體配玻璃擬態，浪漫至極'
  },
  {
    id: 2,
    name: '紫羅蘭之約',
    style: 'elegant',
    primaryColor: '#8b5cf6',
    secondaryColor: '#c4b5fd',
    preview: '/template-previews/elegant.jpg',
    description: '優雅紫金 Art Deco 風格，三欄圖片卡設計，華麗對稱'
  },
  {
    id: 3,
    name: '金輝盛典',
    style: 'luxury',
    primaryColor: '#1f2937',
    secondaryColor: '#fbbf24',
    preview: '/template-previews/luxury.jpg',
    description: '全黑金配色，雜誌堆疊版型，Black-tie 奢華風格'
  },
  {
    id: 4,
    name: '翠綠田園',
    style: 'natural',
    primaryColor: '#10b981',
    secondaryColor: '#6ee7b7',
    preview: '/template-previews/natural.jpg',
    description: '自然植物插畫框，牛皮紙質感，戶外花園婚禮專屬'
  },
  {
    id: 5,
    name: '喜氣洋洋',
    style: 'traditional',
    primaryColor: '#DC2626',
    secondaryColor: '#D4A017',
    preview: '/template-previews/traditional.jpg',
    description: '傳統中式紅金配色，囍字雲紋，古典喜帖風格'
  }
];

export const COVER_IMAGE_OPTIONS = [
  'https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1469371670807-013ccf25f16a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1507504031003-b417219a0fde?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
];
